/**
 * EscapeSystem - Système de jeu Escape (étapes avec timer)
 * Identique à Flutter EscapeSystem
 */

import {SimpleSystem} from '../simple/SimpleSystem';
import GameRegistry from '../GameRegistry';
import {TimedStepExtraFieldType} from './extraFields/TimedStepExtraFieldType';
import {TimeToFinishExtraFieldType} from './extraFields/TimeToFinishExtraFieldType';
import SimpleTimedStepWidget from './widgets/SimpleTimedStepWidget';
import PasswordTimedStepWidget from './widgets/PasswordTimedStepWidget';
import React from 'react';
import {PlayerStep} from '../../models/PlayerStep';
import {ExtraFieldType} from '../types/ExtraFieldType';
import {TimedStepType, TimedPasswordStepType} from './step/TimedStepType';

export class EscapeSystem extends SimpleSystem {
  private _adventureExtraFieldTypes: ExtraFieldType[] | null = null;

  constructor() {
    super(); // Enregistre les conditions de base
    this._registerExtraFields();
    this._registerStepBuilders();
  }

  /**
   * Enregistre les extraFields Escape
   */
  private _registerExtraFields(): void {
    console.log('[EscapeSystem] Registering extraFields...');
    // TimedStepExtraFieldType : pour les étapes (stepExtraField)
    GameRegistry.registerStepExtraFieldType(new TimedStepExtraFieldType());
    // TimeToFinishExtraFieldType : pour l'aventure (adventureExtraField)
    const timeToFinishType = new TimeToFinishExtraFieldType();
    GameRegistry.registerAdventureExtraFieldType(timeToFinishType);
    
    // Stocker les types d'aventure pour getAdventureExtraFieldTypes()
    this._adventureExtraFieldTypes = [timeToFinishType];
    
    console.log('[EscapeSystem] Registered adventure extraField: ESCAPE_TIME_TO_FINISH');
    console.log('[EscapeSystem] Registered step extraField: TIMED');
  }

  /**
   * Retourne les types d'extraFields déclarés pour l'aventure dans ce système
   * Agnostique : le GameStateHelper utilise cette méthode pour savoir quels extraFields initialiser
   */
  getAdventureExtraFieldTypes(): ExtraFieldType[] {
    // Retourner uniquement les types d'aventure (pas les stepExtraFields comme TIMED)
    return this._adventureExtraFieldTypes || [];
  }

  /**
   * Enregistre les builders de step Escape
   */
  private _registerStepBuilders(): void {
    // STEP_TIMED_SIMPLE : étape simple avec timer
    GameRegistry.registerStepBuilder('STEP_TIMED_SIMPLE', (step: PlayerStep) => {
      return React.createElement(SimpleTimedStepWidget, {step});
    });

    // STEP_TIMED_PASSWORD : étape mot de passe avec timer
    GameRegistry.registerStepBuilder('STEP_TIMED_PASSWORD', (step: PlayerStep) => {
      return React.createElement(PasswordTimedStepWidget, {step});
    });

    // Enregistrer les StepTypes pour que GameStateHelper puisse utiliser getStepExtraFieldTypes()
    const timedStepType = new TimedStepType();
    GameRegistry.registerStepType(timedStepType);
    const timedPasswordStepType = new TimedPasswordStepType();
    GameRegistry.registerStepType(timedPasswordStepType);

    console.log('[EscapeSystem] Registered step builders: STEP_TIMED_SIMPLE, STEP_TIMED_PASSWORD');
  }
}
